import { useState } from 'react';
import { getNumberWrapper, numberFormatter, NumberFormat } from 'easit--localization';
import React from 'react';

const numberWithDecimalReqEx = /^[0-9,\.]$/; // intended one number
const numberRegEx = /^[0-9]$/;

/* Input to fill stake, specific (dynamic format with/without decimal point), number keyboard with problem with missing decimal point in ios 11
 * Sets class is-invalid if invalid (similar to Bootstrap).
*/
export const NumberInputForStake: React.FC<INumberInputForStakeProps> = (props: INumberInputForStakeProps) => {
    const [stateIsValid, stateSetValid] = useState<boolean>(true);
    const [stateTextValue, stateSetTextValue] = useState<string>(formatValueForUser(props.value));

    let numberWrapper = getNumberWrapper();

    React.useEffect(() => {
        //state has changed in onChange or props.value has changed
        if (stateIsValid) {
            let rawValue = props.canUseDecimals ? numberWrapper.getFloatValueFromUserText(stateTextValue) : numberWrapper.getIntValueFromUserText(stateTextValue);
            if (rawValue != props.value) {  //to disable reformat when still editing
                stateSetTextValue(formatValueForUser(props.value));
                stateSetValid(true);
                return;
            }
        } else {
            if (props.value != null) { //null comes as invalid
                stateSetTextValue(formatValueForUser(props.value));
                stateSetValid(true);
            }
        }
    }, [props.value]);

    function formatValueForUser(value: number) {
        if (props.canUseDecimals || value % 1 != 0) {
            return numberFormatter.formatNoThousandSeparator(value);
        }
        return numberFormatter.formatNoThousandSeparator(value, NumberFormat.Integer);
    }

    function onChange(event: any) {
        let textValue = event.target.value;
        let isValid = props.canUseDecimals ? numberWrapper.checkUserFloatValue(textValue) : numberWrapper.checkUserIntValue(textValue);
        if (isValid) {
            if (props.onChange) {
                props.onChange(true, props.canUseDecimals ? numberWrapper.getFloatValueFromUserText(textValue) : numberWrapper.getIntValueFromUserText(textValue));
            }
        } else {
            var newValue = "";
            for (let i = 0; i < textValue.length; i++) {
                if (props.canUseDecimals && numberWithDecimalReqEx.test(textValue[i]) || !props.canUseDecimals && numberRegEx.test(textValue[i])) {
                    newValue += textValue[i];
                }
            }
            textValue = newValue;
            isValid = props.canUseDecimals ? numberWrapper.checkUserFloatValue(textValue) : numberWrapper.checkUserIntValue(textValue);
            if (props.onChange) {
                if (isValid) {
                    props.onChange(true, props.canUseDecimals ? numberWrapper.getFloatValueFromUserText(textValue) : numberWrapper.getIntValueFromUserText(textValue));
                } else {
                    props.onChange(false);
                }
            }
        }
        stateSetValid(isValid);
        stateSetTextValue(textValue);
    }

    function onBlur(event: React.FocusEvent<HTMLInputElement>) {
        if (stateIsValid) {
            let value = props.canUseDecimals ? numberWrapper.getFloatValueFromUserText(event.target.value) : numberWrapper.getIntValueFromUserText(event.target.value); //TODO why not stateValue?
            let formatted = formatValueForUser(value);
            if (event.target.value !== formatted) {
                stateSetTextValue(formatted);
            }
            if (props.onBlur) {
                props.onBlur();
            }
        }
        else {
            // prevents are ignored
            event.preventDefault();
            event.stopPropagation();
        }
    }

    function onKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.which == 13 || event.keyCode == 13) {//enter, for go button
            event.preventDefault();
            event.stopPropagation();
            if ((event.target as any).blur) {
                (event.target as any).blur();
            }
            return;
        }
        let prevent = false;
        if (stateTextValue.indexOf('.') >= 0 || stateTextValue.indexOf(',') >= 0) {
            if (props.canUseDecimals) {
                if (numberRegEx.test(event.key)) {
                    return;
                }
            }
            prevent = true;
        }

        if (prevent || props.canUseDecimals && !numberWithDecimalReqEx.test(event.key) || !props.canUseDecimals && !numberRegEx.test(event.key)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    return <input
        className={props.className + (!stateIsValid ? " is-invalid" : "")}
        type="text"
        disabled={props.disabled}
        name={props.name}
        value={stateTextValue}
        onChange={onChange.bind(this)}
        onBlur={onBlur.bind(this)}
        onKeyPress={onKeyPress.bind(this)}
        inputMode="numeric" // android
        pattern={(props.canUseDecimals ? "[0-9.,]*" : "[0-9]*")} // ios, firefox*/
        //https://stackoverflow.com/questions/31002146/show-decimal-keyboard-in-html5-ios-7-ios-8
        //https://github.com/mrchandoo/cordova-plugin-decimal-keyboard
        data-test-role={props.roleForTest}
    />
}

interface INumberInputForStakeProps {
    name?: string;
    value: number | null;
    className?: string;
    disabled?: boolean;
    canUseDecimals: boolean;
    roleForTest?: string;
    onChange?: (isValid: boolean, newValue?: number) => void;
    onBlur?: () => void;
};